import {
	REQUEST_USERS,
	RECEIVE_USERS,
	RECEIVE_USERS_ERROR,
	REQUEST_ADD_USER,
	RECEIVE_ADD__USER,
	ADD_USER_ERROR,
	RECEIVE_DELETE_USER,
	REQUEST_DELETE_USER,
	DELETE_USER_ERROR,
	RECEIVE_UPDATE_USER,
	REQUEST_UPDATE_USER,
	UPDATE_USER_ERROR,
	REQUEST_CONFIRM_MAIL,
	RECEIVE_CONFIRM_MAIL,
	CONFIRM_MAIL_ERROR,
} from "../actions/userActionsRedux";
import {
	REQUEST_UPDATE_SELF,
	RECEIVE_UPDATE_SELF,
	UPDATE_SELF_ERROR,
	RECEIVE_LOGOUT_USER,
} from "../actions/activeUserActions";

const initialUsersState = {
	isFetching: false,
	items: [],
	error: null,
};

export const usersReducer = (state = initialUsersState, action) => {
	switch (action.type) {
		case REQUEST_USERS:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true };
		case RECEIVE_USERS:
			//sets new state and fetching ended
			return { ...state, items: action.payload, isFetching: false };
		case RECEIVE_USERS_ERROR:
			//fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case REQUEST_ADD_USER:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_ADD__USER:
			//sets new state and fetching ended
			return {
				...state,
				items: [...state.items, action.payload],
				isFetching: false,
				error: null,
			};
		case ADD_USER_ERROR:
			//fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case REQUEST_DELETE_USER:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_DELETE_USER:
			//filters the users that have been removed
			const newItems = state.items.filter(item => item._id !== action.payload._id);
			return { ...state, items: newItems, isFetching: false, error: null };
		case DELETE_USER_ERROR:
			//fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case REQUEST_UPDATE_USER:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_UPDATE_USER:
			//filters the users that have not been changed and replaces them with the new payload
			const newUsers = state.items.map(item =>
				item._id === action.payload._id ? { ...item, ...action.payload } : item
			);
			return { ...state, items: newUsers, isFetching: false, error: null };
		case UPDATE_USER_ERROR:
			//fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case REQUEST_UPDATE_SELF:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_UPDATE_SELF:
			//filters the users that have not been changed and replaces them with the new payload
			const newUsersSelf = state.items.map(item => {
				return item._id === action.payload._id ? { ...item, ...action.payload } : item;
			});
			return { ...state, items: newUsersSelf, isFetching: false, error: null };
		case UPDATE_SELF_ERROR:
			//fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case REQUEST_CONFIRM_MAIL:
			// keeps state, notifys that fetching started
			return { ...state, isFetching: true, error: null };
		case RECEIVE_CONFIRM_MAIL:
			//filters the users that have not been changed and replaces them with the new payload
			const confirmedUsers = state.items.map(item =>
				item.name === action.payload.oldName ? { ...item, name: action.payload.newName } : item
			);
			return { ...state, items: confirmedUsers, isFetching: false, error: null };
		case CONFIRM_MAIL_ERROR:
			//fetching ended and error is being set
			return { ...state, error: action.payload, isFetching: false };
		case RECEIVE_LOGOUT_USER:
			//sets new state and fetching ended
			return { ...initialUsersState, isFetching: false };
		default:
			return state;
	}
};
